import { makeStyles } from '@material-ui/core'

const syncYourAccountingStyles = makeStyles((theme) => {
    const mobileBreakpoint = theme.breakpoints.down('sm')
    return {
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 24px',
            height: '56px',
            width: '100%',
            position: 'fixed',
            top: 0,
            left: 0,
            backgroundColor: '#fff',
            zIndex: 2
        },
        logo: {
            width: '189px',
            height: '24px'
        },
        loggedInEntity: {
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 500,
            color: '#212121'
        },
        appbar: {
            maxWidth: '100%',
            boxShadow: 'none',
            backgroundColor: '#004B6C !important',
            top: '56px'
        },
        toolbar: {
            height: '80px',
            padding: '16px 0',
            borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)',
            margin: 'auto 14px',
            '& h2': {
                fontSize: '20px',
                lineHeight: '32px',
                fontWeight: 700
            }
        },
        securityBadge: {
            width: '151px',
            display: 'flex',
            padding: '8px',
            borderRadius: '4px',
            fontSize: '12px',
            backgroundColor: 'rgba(255, 255, 255, 0.20)',
            color: '#FFFFFF',
            height: '32px',
            alignItems: 'center'
        },
        secondaryContent: {
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontWeight: 500,
            lineHeight: '2.125rem',
            color: '212121',
            [mobileBreakpoint]: {
                fontSize: '1.25rem'
            }
        },
        whatToExpect: {
            fontFamily: 'Roboto',
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: '1.375rem',
            marginBottom: '-1rem',
            [mobileBreakpoint]: {
                margin: 'auto',
                padding: '1rem 0px'
            }
        },
        bannerTitle: {
            fontFamily: 'Roboto',
            fontSize: '2.625rem',
            lineHeight: '3.625rem',
            letterSpacing: '0em',
            textAlign: 'left',
            [mobileBreakpoint]: {
                paddingBottom: '1rem',
                fontSize: '2rem'
            }
        },
        continueBtn: {
            background: '#007DB8 !important',
            borderRadius: '0.25rem',
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: '1.875rem',
            fontFamily: 'var(--font-family-bold)',
            textTransform: 'capitalize',
            color: 'var(--white) !important',
            marginTop: '1rem',
            width: '100%',
            '&[disabled]': {
                color: 'var(--white) !important',
                backgroundColor: 'var(--disabled) !important'
            }
        },
        flexBoxParent: {
            display: 'flex',
            marginTop: '10rem',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '30px',
            [mobileBreakpoint]: {
                display: 'block',
                margin: 'auto',
                paddingRight: '0px',
                paddingTop: '0px'
            }
        },
        rightBox: {
            // flexDirection: 'column',
            gap: '1.5rem',
            margin: 'auto',
            alignItems: 'center',
            [mobileBreakpoint]: {
                display: 'block',
                paddingRight: '0px',
                paddingLeft: '0px'
            }
        },
        rightInnerBox: {
            [mobileBreakpoint]: {
                width: '100%',
                height: 'auto'
            }
        },
        leftBox: {
            display: 'flex',
            flexDirection: 'column',
            margin: 'auto',
            gap: '2rem',
            alignItems: 'flex-start',
            width: '33.25rem',
            height: '17.625rem',
            [mobileBreakpoint]: {
                display: 'block',
                marginRight: '0px',
                marginLeft: '0px',
                gap: '0px',
                width: '100%',
                height: 'auto'
            }
        },

        btn_primary: {
            color: 'var(--white)',
            backgroundColor: 'var(--teal-blue)',
            '&:hover': {
                color: 'var(--white)',
                backgroundColor: 'var(--teal-blue)'
            }
        },
        applicationText: {
            [mobileBreakpoint]: {
                fontSize: '1.25rem !important'
            }
        },
        faqContainer: {
            margin: '7%'
        },
        companyLogo: {
            display: 'flex',
            flexDirection: 'row'
        },
        customCard: {
            width: '860px',
            margin: '0 auto 24px',
            '& h1': {
                fontSize: '20px',
                lineHeight: '28px',
                fontWeight: 500
            },
            '& h6': {
                fontSize: '16px',
                lineHeight: '22px'
            },
            '& p': {
                fontSize: '12px',
                lineHeight: '16px',
                color: '#757575'
            }
        },
        cardInnerSection: {
            // margin: "20px",
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
        },
        radioContainer: {
            display: 'flex',
            alignItems: 'center',
            '& svg': {
                color: 'var(--teal-blue)',
                height: '20px',
                width: '20px',
                marginLeft: '8px'
            }
        },
        buttoncontainer: {
            position: 'fixed',
            zIndex: 2,
            bottom: 0,
            left: 0,
            right: 0,
            padding: '8px 16px',
            backgroundColor: '#fff',
            display: 'flex',
            justifyContent: 'flex-end',
            fontFamily: 'Arial',
            boxShadow: '0 -2px 10px 0 rgba(0, 0, 0, 0.16)'
        },
        button: {
            maxWidth: '20rem'
        },
        acceptButton: {
            background: '#007DB8 !important',
            borderRadius: '4px',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '20px',
            height: '30px',
            display: 'flex',
            padding: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            textTransform: 'capitalize',
            color: 'var(--white) !important'
        },
        declineButton: {
            color: 'var(--primary-primary-500, #007DB8)',
            textAlign: 'center',

            /* Desktop + Tablet (MD)/Body/Body 2 Medium */
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '20px' /* 142.857% */,
            display: 'flex',
            height: '30px',
            padding: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            borderRadius: '4px'
        },
        declinedDisclaimerNotice: {
            color: '#B71C1C'
        },
        dataPullMainContainer: {
            position: 'relative',
            color: '#212121'
        },
        closeIcon: {
            position: 'absolute',
            top: 0,
            right: 0,
            cursor: 'pointer'
        },
        dataPullContentContainer: {
            padding: '16px 16px 0px 16px'
        },
        dataPullHeading: {
            fontSize: '20px',
            fontWeight: 500,
            paddingBottom: '10px'
        },
        dataPullContents: {
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
        },
        dataPullSubHeading: {
            fontWeight: 500
        },
        dataPullList: {
            paddingLeft: '28px'
        },
        disclosure: {
            color: 'var(--neutrals-grey-600, #757575)',
            fontFamily: 'Roboto',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '16px'
        },
        privacyStatementLink: {
            color: 'inherit',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            fontStyle: 'inherit',
            fontWeight: 'inherit',
            lineHeight: 'inherit',
            textDecorationLine: 'underline',
            textDecorationStyle: 'solid',
            textDecorationSkipInk: 'auto',
            textDecorationThickness: 'auto',
            textUnderlineOffset: 'auto',
            textUnderlinePosition: 'from-font'
        },
        privacyStatementLinkButton: {
            color: 'var(--primary-primary-500,  #007DB8)',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '20px',
            textDecorationLine: 'underline',
            textDecorationStyle: 'solid',
            textDecorationSkipInk: 'auto',
            textUnderlineOffset: 'auto',
            textUnderlinePosition: 'from-font'
        },
        dialogWrapper: {
            display: 'flex',
            padding: '16px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '10px',
            alignSelf: 'stretch'
        },
        dialogTitle: {
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '28px',
            padding: 0,
            alignSelf: 'stretch'
        },
        dialogContentText: {
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '22px',
            margin: 0
        },
        dialogContent: {
            padding: 0,
            alignSelf: 'stretch',
            overflow: 'visible'
        },
        dialogActions: {
            display: 'flex',
            width: '100%',
            paddingLeft: '16px',
            margin: 0,
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        actionButtons: {
            display: 'flex',
            alignItems: 'flex-start'
        }
    }
})

export default syncYourAccountingStyles
